import React, { FC } from 'react'
import { Tag, Tooltip } from 'antd'
import { getStatusIcon } from '@pushly/aqe/lib/components/badges/renderers/status-icons'
import { getClassNames } from '../../../_utils/classnames'

/**
 * Where a domain's Brand Voice stands once Pushly AI is on: set up and applied, or not set up and generation uses the
 * default style. Without Pushly AI there is no status to show; the page itself says Brand Voice comes with it.
 */
export type BrandVoiceState = 'live' | 'notSetUp'

// The platform's canonical status icons, so Live reads the same as Active everywhere else and an absent Brand Voice
// the same as anything disabled.
const LiveIcon = getStatusIcon('ACTIVE')
const NotSetUpIcon = getStatusIcon('DISABLED')

const STATUS: Record<BrandVoiceState, { label: string; tooltip: string; color: string; icon: React.ReactNode }> = {
    live: {
        label: 'Live',
        tooltip: 'Applied to everything Pushly AI writes for this domain.',
        color: 'success',
        icon: <LiveIcon />,
    },
    notSetUp: {
        label: 'Not set up',
        tooltip: 'No Brand Voice is set up, so AI-written content uses the default style.',
        color: 'default',
        icon: <NotSetUpIcon />,
    },
}

/** The Brand Voice's status as an outlined tag, with what it means on hover. */
export const BrandVoiceStatus: FC<{ state: BrandVoiceState }> = ({ state }) => {
    const status = STATUS[state]

    return (
        <Tooltip title={status.tooltip}>
            <Tag variant="outlined" color={status.color} className={getClassNames('bvw-status')} icon={status.icon}>
                {status.label}
            </Tag>
        </Tooltip>
    )
}
